export default __webpack_public_path__ + "static/media/s2s_image_1.3c0a0aab.jpg";